export const splitStringAndReturnValueByIndex = (string, dividers, index) => {
    const regex = new RegExp(`[${dividers}]`, 'g')
    return string.split(regex)[index]
}
